import { useState } from 'react';
import { Link } from 'react-router';
import { MdMenu, MdClose, MdDelete, MdBugReport } from 'react-icons/md';
import { FaInfoCircle, FaSignOutAlt } from 'react-icons/fa';
import applicationSettings from '../../infrastructure/config';
import { CloseOnBlur } from './close-on-blur';
import { FixedDocument } from './fixed-document';
import { NavProps } from './types';

import styles from './MobileNav.module.css';

export const MobileNav = ({ isClearChatDisabled, onClearChat, onAbout, onLogout }: NavProps) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [menuIsClosing, setMenuIsClosing] = useState(false);

  const openMenu = () => {
    setMenuIsOpen(true);
  };

  const closeMenu = () => {
    setMenuIsClosing(true);
    setTimeout(() => {
      setMenuIsOpen(false);
      setMenuIsClosing(false);
    }, 300);
  };

  const clearChat = () => {
    if (isClearChatDisabled) {
      return;
    }
    onClearChat();
    closeMenu();
  };

  const openAbout = () => {
    onAbout();
    closeMenu();
  };

  return (
    <CloseOnBlur onBlur={closeMenu}>
      <div className={styles.mobileNav}>
        {!menuIsOpen && (
          <button className={`btn ${styles.hamburger}`} onClick={openMenu}>
            <span>Menu</span>
            <MdMenu className={styles.navItemIcon} />
          </button>
        )}

        {menuIsOpen && (
          <button className={`btn ${styles.hamburger}`} id={styles.closeBtn} onClick={closeMenu}>
            <span>Menu</span>
            <MdClose className={styles.navItemIcon} />
          </button>
        )}

        {menuIsOpen && (
          <FixedDocument>
            <div>
              <ul
                className={`${styles.listGroup} ${styles.dropdownMenu} ${styles.dropdownList}
              ${menuIsClosing ? styles.animateOut : ''}`}
              >
                <li onClick={clearChat}>
                  <Link
                    to={''}
                    className={`${styles.listGroupItem} ${isClearChatDisabled ? styles.disabledLink : ''}`}
                  >
                    <MdDelete size={'1em'} className={styles.navItemIcon} />
                    <span className={styles.navItemText}>Clear chat</span>
                  </Link>
                </li>

                {!!applicationSettings.reportBugUrl && (
                  <li>
                    <Link
                      to={applicationSettings.reportBugUrl}
                      className={`${styles.listGroupItem}`}
                      onClick={closeMenu}
                    >
                      <MdBugReport size={'1em'} className={styles.navItemIcon} />
                      <span className={styles.navItemText}>Report a bug</span>
                    </Link>
                  </li>
                )}

                <li>
                  <Link to={''} className={`${styles.listGroupItem}`} onClick={openAbout}>
                    <FaInfoCircle className={styles.navItemIcon} />
                    <span className={styles.navItemText}>About</span>
                  </Link>
                </li>

                <li>
                  <Link to={''} className={`${styles.listGroupItem}`} onClick={onLogout}>
                    <FaSignOutAlt className={styles.navItemIcon} />
                    <span className={styles.navItemText}>Sign out</span>
                  </Link>
                </li>
              </ul>
              <div
                className={`${styles.background} ${menuIsClosing ? styles.animateOut : ''}`}
                onClick={closeMenu}
              />
            </div>
          </FixedDocument>
        )}
      </div>
    </CloseOnBlur>
  );
};
